<template>
<div  class="container-fluid">
 
<div class="card border-primary">

  <div class="card-header bg-primary text-white">
    <h4>
        <i class="fas fa-boxes mr-2" aria-hidden="true"></i>  
        CARICO DIRETTO (DDT/FATTURA)
    </h4>

    
  </div>
  
  <div class="card-body">

    <div v-if="type == 'A'">  
    

    <button @click="type='E'" class="btn btn-success ml-2 mt-2 mb-2">      
      
      <i class="far fa-id-card mr-2" aria-hidden="true"></i>
      ANAGRAFICA FORNITORI
      <span v-if="bt_spinner" class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>     
    </button>  


    <!-- SUPPLIER LIST -->    
    <div class="row"> 

        <supplier-select class="ml-3" v-bind:props="supplier" @update="setSupplierId"></supplier-select>

    </div>
    <div class="col-md-4"> 
        <label for="customRange3"><strong>ULTIMI
        <span  class="badge badge-pill badge-primary">{{ range }}</span>
         DOCUMENTI</strong> </label>
    <input type="range" class="custom-range" min="10" max="100" step="10" id="customRange" v-model="range">
    </div>
    
    <button :disabled="!supplier.Id" @click="getData()" class="btn btn-primary mt-1 mb-2">      
      <i class="fas fa-binoculars mr-2" aria-hidden="true"></i>
      LISTA DOCUMENTI [DDT/FATTURA]
      <span v-if="bt_spinner" class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>     
    </button>

   

    </div>
    
    <div v-else-if="type == 'B'">

        <div v-if="sub_type == 'B1'">

            <button  @click="init()" class="btn btn-secondary mt-1 mb-1 mr-2 ml-2">      
                <i style="color:yellow" class="fas fa-reply mr-2" aria-hidden="true"></i>
                RITORNA A LISTA FORNITORI
            </button>

            <!-- BUTTON NEW DOCUMENT -->
            <button  @click="newDocument()" class="btn btn-success mt-1 mb-1  mr-2">      
                <i class="fas fa-file-alt mr-2" aria-hidden="true"></i>
                NUOVO DOCUMENTO
            </button>

            <!-- SUPPLIER DOCUMENT LIST -->
            <documents-list @update="openDocument" :key="refresh" v-bind:range="range"  v-bind:name="supplier.name"  v-bind:supplierId="supplier.Id"></documents-list>
            
        </div>
        <div v-else-if = "sub_type == 'B2'">    
            
   
             <!-- DOCUMENT HEADER -->
            <document-header class="text-center"  v-bind:doc="doc" v-bind:item="doc"></document-header>   

            <div v-if="!add_product">    
                       
                <!-- DOCUMENT PRODUCTS LIST -->
                <div v-if="!productMP">

                     <button v-if="step==1 && !add_product" @click="sub_type = 'B1',add_product=false" class="btn btn-secondary mt-2  mr-2 ml-3">      
                        <i style="color:yellow" class="fas fa-reply mr-2" aria-hidden="true"></i>
                        RITORNA A LISTA DOCUMENTI
                    </button>    

                    <button  @click="addProduct()" class="btn btn-success _add-product mt-2  ml-2">      
                        <i style="color:blue" class="fas fa-edit mr-2" aria-hidden="true"></i>
                        AGGIUNGI PRODOTTO AL DOCUMENTO
                    </button>
                    <document-products  @ProductsDoc="setProductsDoc" @editRow="editProduct" @option="setOption"  v-bind:documentId="doc.documentId" ></document-products> 

                </div>    
                <div v-else>
                    
                    <button  @click="printLabels()" class="btn btn-secondary btn-block mt-1 mb-1 ml-2">      
                        <i style="color:yellow" class="fas fa-reply mr-2" aria-hidden="true"></i>
                        TERMINA E STAMPA ETICHETTE
                    </button>

                    <div class="card">
                        
                        <h5 class="card-header header">
                            CLASSIFICAZIONE     
                            <product-info v-bind:productId="product.productId"></product-info>                
                        </h5>
                        <div class="card-body">
                        
                            <product-market v-bind:item="product" ></product-market>
                            <supplierEAN v-if="company.Id == 59 || company.Id == 57" v-bind:item="product"></supplierEAN>
                        </div>
                    </div>

                   
                    <printZebraModal @close="initDocument()" v-bind:data='barcodesList'></printZebraModal>
                    <print-epl-modal @close="initDocument()" v-bind:data='barcodesList'></print-epl-modal>  


                </div>

    
            </div>    

            <div v-else>
            
                
              

                <!-- PRODUCT -->
                <product v-if="step == 1" @back="add_product=false"   @update="setProduct"  v-bind:productsDoc="productsDoc" v-bind:_product="product" v-bind:doc="doc"></product>

                <!-- STOCK -->
                <stock v-if="step == 2" v-bind:product="product" @back="step=1" @update="setStock"></stock>

                <!-- PRICE LIST -->
                <price-list v-if="step == 3" v-bind:product="product" @update="setProductData" ></price-list>   

                

                <div v-if="step==4">
                    <printZebraModal @close="initDocument()" v-bind:data='barcodesList'></printZebraModal>
                    <print-epl-modal @close="initDocument()" v-bind:data='barcodesList'></print-epl-modal>  
                    <div class="jumbotron jumbotron-fluid mt-15">
                        <div class="container">
                        <h4 class="display-4">STAMPA ETICHETTE</h4>
                        <p class="lead"></p>
                        </div>
                    </div>
                </div>


                 <!-- MODAL MESSAGE IF POST FAILS -->
                <modal-message v-bind:btn="spinner.btn" @close="post">
                   <span slot="body1">{{spinner.msg}}</span>
                </modal-message>
               

            </div>

        </div>

        <div v-else-if="sub_type == 'B3'">
            
            <!-- DOCUMENT HEADER -->
            <document-header class="text-center"  v-bind:doc="doc"></document-header>   
            <edit-product-stock @update="editPriceList" v-bind:item="item" ></edit-product-stock>


        </div>

        <div v-else-if="sub_type == 'B4'">

            <!-- DOCUMENT HEADER -->
            <document-header class="text-center"  v-bind:doc="doc"></document-header>
            <product-info v-bind:productId="item.productId"></product-info> 
            <supplierEAN v-if="company.Id == 59" v-bind:item="item" class="mb-3"></supplierEAN>
            <edit-price-list  @update="setDocumentProducts" v-bind:item="item"></edit-price-list>   
            




        </div>
        
        <div v-else-if="sub_type == 'B5'">
             <!-- DOCUMENT HEADER -->
            <document-header class="text-center"  v-bind:doc="doc"></document-header>   
            <tab :btn_text="'RITORNA A LISTA PRODOTTI'" @close="sub_type = 'B2'" v-bind:product="item" ></tab>
        </div>


        <div v-else>
             <!-- DOCUMENT HEADER -->
            <document-header class="text-center"  v-bind:doc="doc"></document-header>   
            <product-stock @close="sub_type = 'B2'" v-bind:item="item"/>
        </div>    

    </div>

    <div v-else-if="type == 'D'">
        
        <button  @click="type='B'" class="btn btn-secondary mb-1 ml-2">      
            <i style="color:yellow" class="fas fa-reply mr-2" aria-hidden="true"></i>
            RITORNA A LISTA DOCUMENTI
        </button>

        <!-- DOCUMENT -->
        <document v-bind:_doc="doc" v-bind:supplier="supplier.name" @update="setDocument"></document> 

    </div>

    <!-- SUPPLIER LIST -->    
    <div v-else-if="type == 'E'">
        
        <button  @click="type='A'" class="btn btn-secondary mb-2">      
            <i style="color:yellow" class="fas fa-reply mr-2" aria-hidden="true"></i>
            RITORNA A CARICO DIRETTO
        </button>

        <!-- LIST -->
        <supplier-list></supplier-list>

    </div>



  </div>

</div> 

<alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>

</div>    
</template>

<script>

import api               from '@/api'
import alertBox          from '@/components/common/AlertBox.vue';
import supplierSelect    from '@/components/common/SupplierSelect_1.vue'
import documentsList     from '@/components/backOffice/ready/SupplierDocuments.vue'
import document          from '@/components/backOffice/ready/Document.vue'
import documentProducts  from '@/components/backOffice/ready/DocumentProducts.vue'
import documentHeader    from '@/components/backOffice/ready/DocumentHeader.vue'
import product           from '@/components/backOffice/ready/Product.vue'
import stock             from '@/components/backOffice/ready/Stock.vue'
import priceList         from '@/components/backOffice/ready/PriceList.vue'
import editProductStock  from '@/components/backOffice/ready/EditProductStock.vue' 
import editPriceList     from '@/components/backOffice/ready/EditPriceList.vue'
import tab               from '@/components/backOffice/ready/tab/ProductTab.vue'
import productStock      from '@/components/product/productStock.vue' 
import modalMessage      from '@/components/common/ModalMessage.vue' 
import supplierList      from '@/components/supplier/SupplierList.vue'
import printZebraModal   from '@/components/common/PrintZebraModal.vue'
import printEplModal     from '@/components/common/PrintJSPMModal.vue'
import productMarket     from '@/components/backOffice/ready/tab/ProductMarketPlace.vue'
import productInfo       from '@/components/product/ProductInfo.vue'
import supplierEAN       from '@/components/backOffice/ready/tab/SupplierBarcodes.vue'


import { mapGetters }    from 'vuex';

export default {
    
  

    components   : {alertBox,supplierSelect,documentsList,document,documentProducts,documentHeader,product,stock,priceList,editProductStock,editPriceList,tab,productStock,modalMessage,supplierList,printZebraModal,printEplModal,productMarket,productInfo,supplierEAN
    
    
    }, 
    data()
    {
        return{

            supplierEAN  : false,
            range        : 10,
            barcodesList : [],
            type       : 'A',
            sub_type   : 'B1',
            sub_div    : 'A',
            step       : 1,
            add_product : false,
            productsDoc : [],

            msg        : {
                    title : '',
                    body  : '',
                    type  : 0
            },

            bt_spinner : false,
            refresh    : 0,

            doc        : 
            {
              supplierId : null,
              name       : ''                
            },
          
            product    : {
                productId : 0
            },

            spinner    : {
                btn    : false,
                msg    : ''    
            },

            DataToPost : {},
            buttons    : true,
            item       : {},
            productMP  : false,
            printer_type : '',
            supplier        : 
            {
                Id            : 0,
                isActive      : true,
            
                optionBase    : false,
                required      : false,
                small         : true

            },
            
        }
    },
    computed: 
    {
        ...mapGetters(['company']), 

    },
    
    beforeRouteLeave(to,from,next)
    {
        //console.log(to,from)
        next()
    },
    
    
  mounted(){

        history.pushState(null, null, document.URL);

  },
    methods : {
        addProduct()
        {
           
           
            this.add_product = true
            this.step =1
            
        },
        setProductsDoc(products)
        {
            this.productsDoc = products
            

        },
        setOption(product,opt)
        {   
            this.item.productId = product.productId
            this.item.sku = product.sku
            this.item.storeId = product.storeId
            this.item.movementId = product.stockMovementId 



            if(opt=='tab')
            {
                this.sub_type = 'B5'
            }
            else
            {
                this.sub_type = 'B6'
            }    
        },

        
        editProduct(item)
        {
            this.item.productId = item.productId
            this.item.movementId = item.stockMovementId
            this.sub_type = 'B3'


        },
        editPriceList(exit)
        {   
            
            if(exit == 'CLOSE')
            {
                this.sub_type = 'B2'
                
                return    
            }

            this.$store.commit('AUTH_LOGOUT_BTN',true)
            // EDIT PRICE LIST
            this.sub_type = 'B4'
        },
        setDocumentProducts()
        {
            this.sub_type = 'B2'
            this.$store.commit('AUTH_LOGOUT_BTN',false)

        },
        openDocument(item)
        {  
            
            this.doc = item
            
            
            
            this.sub_type = 'B2'
        },
        /*
        setButtons(value)
        {
            this.buttons = value
        },
        */
        init()
        {
            this.type    = 'A'
            this.sub_div = 'A'
            this.step    = 1

            //this.doc.supplierId = null

            this.product = {}
            this.product.productId = 0
            this.product.counter = 1
            

            this.refresh++

        },
        newDocument()
        {
            
            this.product           = {}
            this.product.productId = 0
            
            this.doc.documentId = null
            this.doc.movementId = null
            this.doc.number     = ''
            this.doc.date       = null
            this.doc.typeId     = null
            this.doc.ownerType  = 'S'

            this.type = 'D'

        },
        setSupplierId(Id,text)
        {
            this.supplier.name  = text
            this.supplier.Id    = Id
            this.doc.supplierId = Id
            this.doc.supplier = text

        },
        getData()
        {
            this.type = 'B'
            this.refresh++
        },
        setDocument(doc)
        {  

            this.doc = doc
            this.doc.name = this.supplier.name 
            this.type = 'B'
            this.sub_type = 'B2'
            this.add_product = false
            this.refresh++

        },
        setProduct(product)
        {   
            //this.setButtons()
            this.product = product
            this.step = 2
        },
        setStock(barcodes,sizes,counter)
        {
            
            this.product.barcodes = barcodes
            this.product.counter = counter
            this.product.sizes = sizes
            this.$store.commit('AUTH_LOGOUT_BTN',true)
            this.step = 3

        },

        setProductData(items,labels,discounts)
        {
            
            this.DataToPost = {}

            this.DataToPost.header              = this.doc  
            this.DataToPost.header.discountList = discounts
            this.DataToPost.header.companyId   = this.company.Id          
            this.DataToPost.header.counter     = this.product.counter
            this.DataToPost.body               = items
            this.DataToPost.labels             = labels
            this.post()

        },
        setProductMP()
        {   
            this.add_product = false
            this.productMP = true
        },
        initDocument()
        {
            

            this.productMP         = false
            this.product.productId = 0
            this.product.sku       = ''
            this.product.counter   = 0
            this.type              = 'B'
            this.sub_type          = 'B2'
            this.add_product       = false
            this.step              = 1
            this.$store.commit('AUTH_LOGOUT_BTN',false)
            
        },
        printLabels()        
        {   
            
            
            //this.setButtons(true)

            if(this.printer_type == 'ZPL')

            
                {    
                
                
                this.$nextTick(() => {
                   
                   $('#printZebraModal').modal({keyboard: false,backdrop:'static','show':true});
            
                 })
                
                
                }
                else
                {    
                 this.$nextTick(() => {
                    $('#printEPLModal').modal({keyboard: false,backdrop:'static','show':true});
            
                    })
                }    



        },
        post()
        {   
           
            this.spinner.msg = ''
            this.spinner.btn = false            
           
            $('#spinnerModal').modal({keyboard: false,backdrop:'static','show':true})
            const sp   = {'sp' : 'spCreateBarcode'}
	        const json = Object.assign(this.DataToPost, sp);   
            
            api.post(json).then(res => {
            if(res.status == 200)
            {
                
                this.doc.documentId = res.data.recordsets[0][0].documentId              
                this.doc.movementId = res.data.recordsets[0][0].movementId
                
                this.printer_type = res.data.recordsets[2][0].printer_type
                this.barcodesList = res.data.recordsets[1]

                $('#spinnerModal').modal('hide')

                /* SHOPIFY SYNC PRODUCT/VARIANTS */
                if(this.company.shopify)
                {
                    api.shopifyCreateProductVariants(this.company.Id,this.product.productId)
                                            
                }    


                if(res.data.recordsets[3][0].mp > 0)    
                {
                    this.setProductMP()
                }
                else
                {
                    
                    //this.sub_type = 'B2'
                    this.step     = 4
                    this.printLabels()

                }

                


                
            }
            else if(res.status==500)
            {
                this.spinner.btn = true
                this.spinner.msg = res.data
             
            } 
            else
            {              
              this.spinner.btn = true
              this.spinner.msg = res              

            } 
        }).catch(err => 
        {
          this.spinner.btn = true
          this.spinner.msg = err.message

          

        }).finally(() => {
            
          //this.bt_spinner = false
        });


           
        }




    }
}
</script>

<style scoped>
h4 {
  font-family   : 'Roboto Condensed';
  font-size     : 20px;
}
.pointer:hover
 {
    _color            : beige;
    _background-color : darkgreen;
    
}
.add-product{
  background: darkmagenta;
  color:yellow ;
  font-weight: 400;
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  cursor: pointer;
 
  box-shadow: 1px 1px 3px 0px rgba(0, 0, 0, 0.2);
}
.card-header
{
  height: 45px;
}

.header
{
    height: 70px !important
}
.badge-pill
{
    font-size: large;
}
</style>
